<mat-card>
    <mat-card-content *ngIf="loginService.currentUser$ | async as currentUser">
        <app-activity-results-table [userId]="currentUser.id"></app-activity-results-table>
    </mat-card-content>
</mat-card>
